import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'split-button-card',
  templateUrl: './split-button-card.component.html',
  styleUrls: ['./split-button-card.component.scss']
})
export class SplitButtonCardComponent {


  @Output() public onClick: EventEmitter<any> = new EventEmitter<any>();

  actionClick() {
    this.onClick.emit();
  }

}
